export const MiPath = '/mi'
export const LoginPath = MiPath + '/login'
export const ContractsPath = MiPath + '/contracts'
export const SendEmailPath = MiPath + '/sendEmail'
export const SignupPath = MiPath + '/signup'
export const ResendEmailPath = MiPath + '/resendEmail'
export const ResetPath = MiPath + '/reset'
